export default "__VITE_ASSET__C_QuPpD3__"